/*
*
* File JS componente ROW RUBRICA
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './row-rubrica.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const rowRubrica = () => {
    let allRowsRubrica = document.querySelectorAll('.block-row-rubrica .swiper-container');
    
    if(!allRowsRubrica.length) return;

    let allSwipers = [];
    let initialized = false;

    const initSwipers = () => {
        if (window.innerWidth > 767 || initialized) return;

        allRowsRubrica.forEach((el, i) => {
            let args = {
                slidesPerView: 1,
                breakpoints: {
                    0: {
                        slidesPerView: 1.2
                    },
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    1024: {
                        slidesPerView: 2.5,
                        slidesPerGroup: 2,
                        
                    }
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                    firstSlideMessage: 'This is the first slide',
                    lastSlideMessage: 'This is the last slide',
                    paginationBulletMessage: 'Go to slide {{index}}',
                    notificationClass: 'swiper-notification'
                },
            };
        
            allSwipers[i] = new Swiper(el, args);
        });

        initialized = true;
    };

    initSwipers();

    window.addEventListener('resize', () => {
        if (window.innerWidth > 767 && initialized)
        {
            allSwipers.forEach(el => {
                el.destroy();
            });

            initialized = false;
        }
        else
        {
            if (initialized) return;

            initSwipers();
        }
    });
}

export default rowRubrica;

//--------------------------------------------------------------------//